import { render, staticRenderFns } from "./CDropdown.vue?vue&type=template&id=33fde163&scoped=true"
import script from "./CDropdown.vue?vue&type=script&lang=ts&setup=true"
export * from "./CDropdown.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./CDropdown.vue?vue&type=style&index=0&id=33fde163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fde163",
  null
  
)

export default component.exports